import gsap from 'gsap'
import { useEffect, useState, lazy } from 'react'
import { useLocation } from 'react-router-dom'
import { externalPreload } from '@/utils/dom'

const Post = lazy(() => import(/* webpackChunkName: "post" */'@/pages/Post'))
const Project = lazy(() => import(/* webpackChunkName: "project" */'@/pages/Project'))
const NewProduct = lazy(() => import(/* webpackChunkName: "new_product" */'@/pages/NewProduct'))
const Editorial2025 = lazy(() => import(/* webpackChunkName: "editorial_2025" */'@/pages/Editorial2025'))

function Preview({
  getImageUrl,
  getImageTitle,
  theme,
}) {
  const [currentPostType, setCurrentPostType] = useState('')
  const [currentTemplate, setCurrentTemplate] = useState('')
  const [currentId, setCurrentID] = useState('')
  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const type = searchParams.get('type')
    const postId = searchParams.get('pid')
    setCurrentTemplate(searchParams.get('template'))
    setCurrentPostType(type)
    if (postId) setCurrentID(postId)

    gsap.delayedCall(1.5, externalPreload)
  }, [])

  return (
    <>
      {currentPostType === '_cty_project' ? (
        <Project getImageUrl={getImageUrl} getImageTitle={getImageTitle} theme={theme} cpt="project" preview={currentId} />
      ) : null}
      {currentPostType === 'posts' ? (
        <Post preview={currentId} />
      ) : null}
      {currentPostType === 'family-detail' ? (
        <NewProduct getImageUrl={getImageUrl} getImageTitle={getImageTitle} theme={theme} cpt="family-detail" preview={currentId} />
      ) : null}
      {currentPostType === 'pages' && currentTemplate === 'editorial_2025' ? (
        <Editorial2025 preview={currentId} />
      ) : null}
    </>
  )
}

export default Preview
